module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_3016.c6b69927.png";